
export interface Founder {
  id: number;
  name: {
    en: string;
    ar: string;
  };
  role: {
    en: string;
    ar: string;
  };
  bio: {
    en: string;
    ar: string;
  };
  quote: {
    en: string;
    ar: string;
  };
  education: {
    en: string[];
    ar: string[];
  };
  social: {
    instagram?: string;
    linkedin?: string;
    twitter?: string;
  };
  image: string;
}

export const jointFoundersBio = {
  en: "Two Palestinian activists in human rights, women's empowerment, and climate change. We enjoy traveling and sharing our innovative ideas, culture, and interests with people worldwide. The high importance of the SDGs in Palestine was the crucial factor in participating in this project and showcasing the SDGs in Palestine on a global scale.",
  ar: "ناشطتان فلسطينيتان في مجالات حقوق الإنسان وتمكين المرأة والتغير المناخي. نستمتع بالسفر ومشاركة أفكارنا المبتكرة وثقافتنا واهتماماتنا مع الناس حول العالم. كانت الأهمية الكبيرة لأهداف التنمية المستدامة في فلسطين عاملاً حاسماً للمشاركة في هذا المشروع وإبراز أهداف التنمية المستدامة في فلسطين على المستوى العالمي."
};

export const foundersData: Founder[] = [
  {
    id: 1,
    name: {
      en: "Shahd Edkeidk",
      ar: "شهد إدكيدك"
    },
    role: {
      en: "Co-Founder & Content Lead",
      ar: "المؤسس المشارك ومسؤول المحتوى"
    },
    bio: {
      en: jointFoundersBio.en,
      ar: jointFoundersBio.ar
    },
    quote: {
      en: "Every Palestinian story of sustainability is an act of resistance and hope.",
      ar: "كل قصة فلسطينية عن الاستدامة هي فعل من أفعال المقاومة والأمل."
    },
    education: {
      en: ["MA in Media & Communications, Birzeit University", "BA in Journalism, Al-Quds University"],
      ar: ["ماجستير في الإعلام والاتصالات، جامعة بيرزيت", "بكالوريوس في الصحافة، جامعة القدس"]
    },
    social: {
      instagram: "shahd_storyteller",
      linkedin: "shahd-abuhamda",
      twitter: "shahd_stories"
    },
    image: "/lovable-uploads/d2860ec4-57c3-45c0-9db8-0df12af9bc0e.png"
  },
  {
    id: 2,
    name: {
      en: "Aseel Shabaneh",
      ar: "أسيل شبانة"
    },
    role: {
      en: "Co-Founder & Projects Coordinator",
      ar: "المؤسس المشارك ومنسق المشاريع"
    },
    bio: {
      en: jointFoundersBio.en,
      ar: jointFoundersBio.ar
    },
    quote: {
      en: "Sustainability in Palestine isn't just about the environment—it's about our right to exist and thrive on our land.",
      ar: "الاستدامة في فلسطين ليست فقط متعلقة بالبيئة - بل هي حول حقنا في الوجود والازدهار على أرضنا."
    },
    education: {
      en: ["MSc in Environmental Management, University of Oxford", "BSc in Environmental Science, An-Najah National University"],
      ar: ["ماجستير في الإدارة البيئية، جامعة أكسفورد", "بكالوريوس في العلوم البيئية، جامعة النجاح الوطنية"]
    },
    social: {
      instagram: "aseel_enviroscience",
      linkedin: "aseel-nasser",
      twitter: "aseel_sustain"
    },
    image: "/lovable-uploads/6494c85c-e438-4cbe-bc63-bc2c8df9fb99.png"
  }
]
